import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"
import cx from "classnames"

import Container from "@components/elements/container"
import Link from "@components/elements/link"
import SocialLinks from "@components/elements/socialLinks"
import Cta from "@components/elements/cta"
import { internalRoutes } from "@data/routes"

import Logo from "@images/logo.inline.svg"
import LogoIcon from "@images/logo-icon-light.inline.svg"

import styles from "./footer.module.scss"

const DATA_MAIN_NAVIGATION_ITEMS = [
  {
    title: "Solutions",
    url: internalRoutes.SOLUTIONS,
  },
  {
    title: "R+D Roadmap",
    url: internalRoutes.ROADMAP,
  },
  {
    title: "Technology",
    url: internalRoutes.TECHNOLOGY,
  },
  {
    title: "Decarbonization",
    url: internalRoutes.DECARBONIZATION,
  },
  {
    title: "Resources",
    url: internalRoutes.RESOURCES,
  },
  {
    title: "About",
    url: internalRoutes.ABOUT,
    isSecondary: true,
  },
  {
    title: "News",
    url: internalRoutes.NEWS,
    isSecondary: true,
  },
  {
    title: "Careers",
    url: internalRoutes.CAREERS,
    isSecondary: true,
  },
]

const DATA_BOTTOM_NAVIGATION_ITEMS = [
  {
    title: "Terms of Service",
    url: internalRoutes.TERMS_OF_SERVICE,
  },
  {
    title: "Privacy Policy",
    url: internalRoutes.PRIVACY_POLICY,
  },
  {
    title: "Code of Conduct & Anti-Corruption Policy",
    url: internalRoutes.COC_ACP,
  },
]

const Footer = () => (
  <footer className={styles.footer}>
    <div className={styles.content}>
      <Container className={styles.container}>
        <Link className={styles.logo} url={internalRoutes.HOME}>
          <Logo className={styles.logoFull} />
          <LogoIcon className={styles.logoIcon} />
        </Link>
        <Cta
          className={styles.ctaButton}
          text="Contact"
          url={internalRoutes.CONTACT}
          color="light"
          variant="secondary"
        />
        <ul className={styles.navigation}>
          {DATA_MAIN_NAVIGATION_ITEMS.map(navItem => (
            <li key={navItem.title}>
              <Link
                className={cx(styles.navigationLink, {
                  [styles.isSecondary]: navItem?.isSecondary,
                })}
                url={navItem.url}
              >
                {navItem.title}
              </Link>
            </li>
          ))}
        </ul>
        <Cta
          className={styles.ctaLink}
          text="Join our newsletter"
          url={`${internalRoutes.CONTACT}#newsletter`}
          variant="link"
          color="light"
          onClick={() => {
            window.scroll({ top: 0 })
          }}
        />
        <SocialLinks className={styles.socialLinks} />
        <div className={styles.detailsLink}>
          calculate carbon footprint:
          <br />
          <Link url="https://carbonmodel.com/">carbonmodel.com</Link>
        </div>
        <div className={styles.copyright}>
          ©{new Date().getFullYear()} Syzygy Plasmonics. All Rights Reserved.
          <ul className={styles.legalLinks}>
            {DATA_BOTTOM_NAVIGATION_ITEMS.map(navItem => (
              <li key={navItem.title}>
                <Link url={navItem.url}>{navItem.title}</Link>
              </li>
            ))}
          </ul>
        </div>
      </Container>
    </div>
    <StaticImage
      className={styles.background}
      quality={100}
      src="../../images/bg-gradient-1.jpg"
      placeholder="dominantColor"
      objectPosition={"left bottom"}
      alt=""
    />
  </footer>
)

export default Footer
